import { Body, Box, Divider, Link, Stack } from '@hover/blueprint';
import { Link as GatsbyLink } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import React, { FC, useState } from 'react';
import { FooterContact } from './FooterContact';
import FooterMobileItems from './FooterMobileItems';
import { FooterProps } from './types';

export interface FooterMobileProps extends FooterProps {}

const FooterMobile: FC<FooterMobileProps> = ({
  contact,
  copyrightText,
  footerBottomItems,
  links,
}) => {
  const [activeTabLabel, setActiveTabLabel] = useState<string | null>(null);

  function handleActiveTab(label: string) {
    if (activeTabLabel === label) setActiveTabLabel(null);
    else setActiveTabLabel(label);
  }

  return (
    <Box flexDir="column" w="100%">
      <Box flexDir="column" px={500}>
        <FooterContact {...contact} />
        <Stack py={500} d={{ desktop: 'none', base: 'flex' }}>
          <Divider
            opacity={1}
            borderColor="brandNavy.300"
            orientation="horizontal"
            borderWidth="1px"
            borderTopWidth={0}
            my={0}
          />
          {links.map(navItem => (
            <FooterMobileItems
              label={navItem.label}
              links={navItem.links}
              key={navItem.label}
              isOpen={activeTabLabel === navItem.label}
              onToggle={() => {
                handleActiveTab(navItem.label);
              }}
            />
          ))}
        </Stack>
        <Box
          mt={600}
          display="flex"
          flexWrap="wrap"
          justifyContent="space-between"
          alignItems="center"
          pb={700}
        >
          {footerBottomItems.map(({ label, to }) => (
            <Link
              as={GatsbyLink}
              to={to}
              minW="29%"
              my={300}
              flexGrow={1}
              color="brandNavy.200"
              textAlign="center"
              letterSpacing="0.15em"
              _hover={{ color: 'primary.500' }}
              _active={{ color: 'primary.300' }}
              key={label}
              size={300}
              fontWeight="bodyBold"
              textTransform="uppercase"
            >
              {label}
            </Link>
          ))}
        </Box>
      </Box>
      <Divider
        borderColor="brandNavy.300"
        orientation="horizontal"
        opacity={1}
        borderWidth="1px"
        borderTopWidth={0}
        my={0}
      />
      <Box
        py={500}
        px={500}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Body color="brandNavy.200" size={300} isSemiBold>
          {copyrightText}
        </Body>
        <StaticImage
          quality={100}
          placeholder="blurred"
          src="../../../assets/images/SOC.png"
          alt="SOC logo service organization"
          width={56}
          height={56}
        />
      </Box>
    </Box>
  );
};

export default FooterMobile;
